module.exports = __webpack_public_path__ + "img/logo.fbefbe23.9afea011.png";